package dev.krno.components

import androidx.compose.runtime.Composable
import dev.krno.data.EventData
import dev.krno.data.Slot
import dev.krno.data.Speaker
import org.jetbrains.compose.web.dom.AttrBuilderContext
import org.jetbrains.compose.web.dom.ContentBuilder
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.ElementBuilder
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.TagElement
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.HTMLElement

@Composable
fun Program(onOpenSpeaker: (Speaker) -> Unit) {
    Section(attrs = {
        id("program")
        classes("wrap")
        style { property("padding-bottom", "56px") }
    }) {
        Div(attrs = { classes("program") }) {
            Div(attrs = { classes("head") }) {
                Div {
                    Div(attrs = {
                        classes("label")
                        style { property("margin-bottom", "14px") }
                    }) { Text("Program") }
                    H2 { Text("One Tuesday evening") }
                }
                P {
                    Text(
                        "Doors at 17:30. Talks and Q&A are in English. Cake at 20:10."
                    )
                }
            }
            EventData.program.forEach { slot ->
                val speaker = matchSpeaker(slot)
                Div(attrs = {
                    classes("slot")
                    if (slot.break_) classes("break")
                    if (slot.party) classes("party")
                    if (speaker != null) {
                        classes("slot-talk")
                        attr("role", "button")
                        attr("tabindex", "0")
                        attr("aria-label", "Open details for ${speaker.name.ifEmpty { "speaker" }}")
                        onClick { onOpenSpeaker(speaker) }
                        onKeyDown { evt ->
                            val key = evt.asDynamic().key as? String
                            if (key == "Enter" || key == " ") {
                                evt.preventDefault()
                                onOpenSpeaker(speaker)
                            }
                        }
                    }
                }) {
                    Time { Text(slot.time) }
                    Div {
                        H3 { Text(slot.title) }
                        Div(attrs = { classes("who") }) { Text(slot.who) }
                    }
                    Span(attrs = { classes("tag") }) { Text(slot.tag) }
                }
            }
        }
    }
}

// Match a program slot to a speaker so clicking a talk row opens the modal.
// The slot's `who` field starts with the speaker's name (e.g. "Wout Werkman · JetBrains"),
// so a startsWith comparison against each speaker's name is enough for the current data.
private fun matchSpeaker(slot: Slot): Speaker? {
    if (slot.party) return EventData.birthdayParty
    if (slot.tag != "Talk") return null
    return EventData.speakers.firstOrNull { s ->
        s.name.isNotEmpty() && slot.who.startsWith(s.name)
    }
}

@Composable
private fun Time(
    attrs: AttrBuilderContext<HTMLElement>? = null,
    content: ContentBuilder<HTMLElement>? = null,
) {
    TagElement(
        elementBuilder = ElementBuilder.createBuilder("time"),
        applyAttrs = attrs,
        content = content,
    )
}
